import styled from 'styled-components';

// Estilos para el contenedor del search bar
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Montserrat, sans-serif;
  background-color: #0d1117;
  color: #c9d1d9;
  padding: 20px;
  height: 100%;
  width: 100%;
`;